import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';

import appReducer from './store/reducers/AppReducer';
import authReducer from './store/reducers/AuthReducer';
import uiReducer from './store/reducers/UiReducer';
import projectsReducer from './store/reducers/ProjectsReducer';
import projectTreeReducer from './store/reducers/ProjectTreeReducer';
import actionsReducer from './store/reducers/FlowActionsReducer';
import distributionsReducer from './store/reducers/DistributionsReducer';
import distributionTreeReducer from './store/reducers/DistributionTreeReducer';
import clipListReducer from './store/reducers/ClipListReducer';
import commentsReducer from './store/reducers/CommentsReducer';
import profilesReducer from 'store/reducers/ProfilesReducer';
import UploadFilesReducer from 'store/reducers/UploadFilesReducer';
import roomsReducer from 'store/reducers/RoomsReducer';
import cartReducer from 'store/reducers/CartReducer';
import adminReducer from 'store/reducers/AdminReducer';
import userReducer from 'store/reducers/UserReducer';
import metadataReducer from 'store/reducers/MetadataReducer';
import devicesReducer from 'store/reducers/DevicesReducer';
import mediafileReducer from 'store/reducers/MediafileReducer';
import vimeoReducer from 'store/reducers/VimeoReducer';

import clipReducer from 'store/reducers/ClipReducer';
import searchReducer from 'store/reducers/SearchReducer';
import customDataReducer from 'store/reducers/CustomDataReducer';

import notificationReducer from 'store/reducers/NotificationReducer';
import notificationApprovalUserReducer from 'store/reducers/NotificationApprovalUserReducer';
import notificationSenderUserReducer from 'store/reducers/NotificationSenderUserReducer';

import thunk from 'redux-thunk';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
    app: appReducer,
    auth: authReducer,
    ui: uiReducer,
    projects: projectsReducer,
    projectTree: projectTreeReducer,
    profiles: profilesReducer,
    uploadFiles: UploadFilesReducer,
    flowActions: actionsReducer,
    distributions: distributionsReducer,
    distributionTree: distributionTreeReducer,
    rooms: roomsReducer,
    clipList: clipListReducer,
    clip: clipReducer,
    comment: commentsReducer,
    search: searchReducer,
    cart: cartReducer,
    customData: customDataReducer,
    admin: adminReducer,
    user: userReducer,
    metadata: metadataReducer,
    notification: notificationReducer,
    notificationApprovalUser: notificationApprovalUserReducer,
    notificationSenderUser: notificationSenderUserReducer,
    devices: devicesReducer,
    mediafiles: mediafileReducer,
    vimeo: vimeoReducer
});

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

let state = store.getState();

import(`./${process.env.REACT_APP_APPID}/App`).then((Module) => {
    const App = Module.default;
    const app = (
        <Provider store={store}>
            <BrowserRouter basename={process.env.REACT_APP_BASEPATH}>
                <App />
            </BrowserRouter>
        </Provider>
    );

    //ReactDOM.render(<Flow2 />, document.getElementById('root'));
    ReactDOM.render(app, document.getElementById('root'));

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: http://bit.ly/CRA-PWA
    serviceWorker.unregister();

})

export default store;
